module.exports = __webpack_public_path__ + "img/clapper_board.115814f9.gif";